export const pinSvg = (color) => ({
  path:
    "M158 666c-58-22-87-46-113-91-46-77-31-167 40-245 55-60 89-151 101-267 5-51 9-63 24-63 18 0 30 40 30 101 0 43 40 151 73 197 82 113 87 124 87 182 0 45-6 65-29 102-46 72-142 110-213 84z",
  fillColor: color || "#0000FF",
  fillOpacity: 1,
  strokeWeight: 2,
  strokeColor: "black",
  scale: 0.09,
  anchor: { x: 21, y: 68 },
  rotation: 180,
});
